/* Ruby Rose — product page behaviour.
   Accordions use native <details>, so they need no JavaScript and keep working
   if this file fails to load. Everything here is progressive enhancement over
   markup that is already usable. */

(function () {
  function initGallery(root) {
    const thumbs = [...root.querySelectorAll("[data-rr-thumb]")];
    const slides = [...root.querySelectorAll("[data-rr-slide]")];
    if (!thumbs.length || !slides.length) return;

    const show = (index) => {
      slides.forEach((slide) => {
        const active = slide.dataset.rrSlide === String(index);
        slide.classList.toggle("is-active", active);
        slide.toggleAttribute("aria-hidden", !active);
      });
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.rrThumb === String(index);
        thumb.classList.toggle("is-active", active);
        if (active) thumb.setAttribute("aria-current", "true");
        else thumb.removeAttribute("aria-current");
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => show(thumb.dataset.rrThumb));
      // Arrow keys move between thumbnails, matching a listbox's feel.
      thumb.addEventListener("keydown", (event) => {
        const i = thumbs.indexOf(thumb);
        let next = null;
        if (event.key === "ArrowDown" || event.key === "ArrowRight") next = thumbs[i + 1];
        if (event.key === "ArrowUp" || event.key === "ArrowLeft") next = thumbs[i - 1];
        if (next) {
          event.preventDefault();
          next.focus();
          show(next.dataset.rrThumb);
        }
      });
    });
  }

  function initShades(root) {
    const wrap = root.querySelector("[data-rr-shades]");
    if (!wrap) return;

    // Tabs filter the swatch list by colour taxonomy.
    const tabs = [...wrap.querySelectorAll("[data-rr-tab]")];
    const items = [...wrap.querySelectorAll(".rr-pdp__swatches > li")];

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const key = tab.dataset.rrTab;
        tabs.forEach((t) => t.classList.toggle("is-active", t === tab));
        items.forEach((li) => {
          const keys = (li.dataset.rrSwatchTax || "").split(/\s+/);
          li.hidden = key !== "all" && !keys.includes(key);
        });
      });
    });

    // The dropdown mirrors the swatches: each option is a sibling product URL.
    const select = wrap.querySelector("[data-rr-shade-select]");
    if (select) {
      select.addEventListener("change", () => {
        if (select.value) window.location.href = select.value;
      });
    }
  }

  function initReviews(root) {
    const box = root.querySelector("[data-rr-reviews]");
    if (!box) return;

    const dots = [...box.querySelectorAll("[data-rr-dot]")];
    const reviews = [...box.querySelectorAll("[data-rr-review]")];
    if (!dots.length) return;

    let current = Math.max(0, dots.findIndex((d) => d.classList.contains("is-active")));

    function show(index) {
      current = ((index % dots.length) + dots.length) % dots.length;
      const key = String(current);
      reviews.forEach((r) => r.classList.toggle("is-active", r.dataset.rrReview === key));
      dots.forEach((d) => {
        const active = d.dataset.rrDot === key;
        d.classList.toggle("is-active", active);
        d.setAttribute("aria-selected", active ? "true" : "false");
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        show(Number(dot.dataset.rrDot));
        // Choosing a review is a statement of intent; carrying on rotating
        // would pull the page out from under whoever just chose.
        stop();
      });
    });

    /* ---- Auto-advance ----
       Off unless the section asks for it, and off regardless for anyone who
       has asked their system to reduce motion — text that moves on its own is
       exactly what that setting is for. */
    const seconds = Number(box.dataset.rrInterval || 0);
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!seconds || dots.length < 2) return;

    let timer = null;

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function start() {
      if (timer || reduceMotion.matches || document.hidden) return;
      timer = setInterval(() => show(current + 1), seconds * 1000);
    }

    /* Pause while it is being read or operated. Hover covers the mouse,
       focusin covers the keyboard, and together they are what makes a
       self-advancing panel tolerable rather than a thing to fight. */
    box.addEventListener("pointerenter", stop);
    box.addEventListener("pointerleave", start);
    box.addEventListener("focusin", stop);
    box.addEventListener("focusout", (event) => {
      if (!box.contains(event.relatedTarget)) start();
    });

    // No point cycling in a background tab, and it desynchronises the timer.
    document.addEventListener("visibilitychange", () => (document.hidden ? stop() : start()));
    reduceMotion.addEventListener?.("change", () => (reduceMotion.matches ? stop() : start()));

    start();
  }

  function init() {
    document.querySelectorAll("[data-rr-pdp]").forEach((root) => {
      initGallery(root);
      initShades(root);
      initReviews(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
